import React, { useContext, useEffect } from 'react';
import AddNewItem from '../../pieces/AddNewItem';
import checkEmptyObject from '../../../../utils/checkEmptyObject';
import { UserDispatchContext, UserStateContext } from './CreateEditUserProvider';
import FormInfoUser from './FormInfoUser';

const AddNewUser = () => {
  const {
    state: { errors, items },
    loading,
    handleNewUser,
  } = useContext(UserStateContext);
  const dispatch = useContext(UserDispatchContext);

  useEffect(() => {
    dispatch({
      type: 'CLEAR_STATE',
    });
  }, [dispatch]);

  return (
    <AddNewItem
      disableSubmit={checkEmptyObject(errors).length > 0}
      items={items}
      loading={loading}
      dispatch={dispatch}
      handleSubmit={handleNewUser}
      labelSubmit="Convidar"
      msgSubmit="Tem a certeza que deseja convidar o novo utilizador?"
    >
      <FormInfoUser isAddNew />
    </AddNewItem>
  );
};

export default React.memo(AddNewUser);
